import { ICartEntry } from './cart-entry';
import { OfferItem } from './offer';

export class OnlineStoreCartEntry implements ICartEntry {
    constructor(public item: OfferItem, public quantity: number, public exists: boolean,
        public isServerSoldOut: boolean, public sold: number
    ) {}
}